import React from 'react';
import PropTypes from 'prop-types';
import ReferralInfoContext from './ReferralInfoContext';
import { fetchReferralInfo } from '../../api/storefront';

export default class ReferralInfoProvider extends React.Component {
  loading = false;

  constructor(props) {
    super(props);
    /**
     * ReferralInfo is initially undefined.
     * This is used to indicate a pending request.
     * When referralInfo is defined, that means the request is finished.
     * It will be an empty object if no referralInfo.
     * It will be an object with more info if there are referralInfo.
     */
    this.state = {
      referralInfo: undefined,
    };
  }

  /**
   * Load Once if needed
   */
  ensureReferralInfo = async () => {
    if (this.loading) {
      return;
    }
    this.loading = true;
    // Grab `kid` from query params and pass through to referral Info.
    const kid = new URLSearchParams(window.location.search).get('kid');
    const referralInfo = await fetchReferralInfo(kid);
    this.setState({ referralInfo });
  };

  render() {
    const { referralInfo } = this.state;
    return (
      <ReferralInfoContext.Provider
        value={{ referralInfo, ensureReferralInfo: this.ensureReferralInfo }}>
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.props.children}
      </ReferralInfoContext.Provider>
    );
  }
}

ReferralInfoProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
